import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, Icon, Link } from '@Sage/hoi-poi-ui';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'ActionLink');

const ActionLink = ({ icon: iconName = 'add', text, onClick, className }) => {
    const classes = useStyles();

    const linkProps = useMemo(
        () => ({
            className: classNames(classes.root, className),
            onClick,
        }),
        [className, classes.root, onClick],
    );

    return (
        <Link {...linkProps}>
            <span>{text}</span>
            <Icon name={iconName} />
        </Link>
    );
};

export default memo(ActionLink);
